<rappider-title-bar [mainTitle]="mainTitle"
                    [mainTitleButton]="mainTitleButton"
                    [options]="options"
                    [displayGripButton]="displayGripButton"
                    [displayBreadcrumb]="displayBreadcrumb"
                    [switchSettings]="titleBarSwitchSettings"
                    [actionButtons]="titleBarActionButtons"
                    [dropdownMenu]="titleBarActionMenu"
                    [isSwitchVisible]="isSwitchVisible"
                    [radioButtonSettings]="titleBarRadioButtonSettings"
                    (radioButtonClick)="onTitleBarRadioButtonClick($event)"
                    (switchToggled)="onSwitchToggled($event)"
                    (actionButtonClick)="onTitleBarActionButtonClick($event)"
                    (actionButtonConfirm)="onTitleBarActionButtonConfirm($event)"
                    (doneClick)="onJoyrideDoneButtonClick()"
                    (menuItemClick)="onTitleBarActionMenuClick($event)"
                    (optionClick)="onBreadCrumbOptionClicked($event)"
                    (gripButtonClicked)="onGripButtonClicked($event)"></rappider-title-bar>

<rappider-toolbar *ngIf="displayToolbar"
                  [displayBackButton]="displayToolbarBackButton"
                  [toolbarButtons]="toolbarButtons"
                  (toolbarButtonClick)="onToolbarButtonClick($event)"
                  (backButtonClick)="onBackButtonClick($event)"></rappider-toolbar>
